import { useEffect, useRef, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearUserAuthorize, clearAuthMultipleAccounts } from 'store/actions';

// Import context
import { AuthenticationContext } from 'components/context/authentication/AuthenticationProvider';

// Import helpers
import { POST_SUBSCRIBER_LOGIN_API } from 'helpers/api';

// Import utilities
import { useAuthorization } from 'components/utilities';

const useLoginForm = () => {
	const dispatch = useDispatch();
	const formRef = useRef();
	const { authError, isAuthenticated } = useSelector(({ auth }) => auth);
	const { handleLoader } = useContext(AuthenticationContext);
	const { token: providerToken } = useSelector(({ provider }) => provider);

	const { userAuthorization } = useAuthorization({
		apiUrl: POST_SUBSCRIBER_LOGIN_API,
		multiAccount: true,
		providerToken
	});

	useEffect(() => {
		clearUserAuthorize()(dispatch);

		return () => clearAuthMultipleAccounts()(dispatch);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		const { setSubmitting } = formRef.current;

		if (authError.isError) {
			handleLoader(false);
			setSubmitting(false);
		}

		isAuthenticated && setSubmitting(false);
		// eslint-disable-next-line
	}, [authError.isError, isAuthenticated]);

	const initialValues = { login: '', password: '' };

	const handleSubmit = (values) => {
		clearUserAuthorize()(dispatch);
		userAuthorization(values);
	};

	return { formRef, initialValues, authError, submit: handleSubmit };
};

export default useLoginForm;
